import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill, EmptyState } from "@/components/Bits";
import { Bell, CheckCircle } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    load();
  };

  return (
    <div>
      <PageHeader eyebrow="Inbox" title="Notifications" subtitle="Everything that needs your attention." />
      {items.length === 0 ? <EmptyState title="You're all caught up" hint="No new notifications right now." /> : (
        <div className="space-y-2 max-w-3xl">
          {items.map(n => (
            <div key={n.notification_id} className={`bg-white border ${n.read ? "border-border" : "border-terracotta"} rounded-2xl p-4 flex items-start gap-3`}>
              <span className="w-10 h-10 rounded-xl bg-terracotta-soft text-terracotta flex items-center justify-center"><Bell weight="duotone" /></span>
              <div className="flex-1">
                <div className="font-semibold">{n.title}</div>
                <div className="text-sm text-ink-soft mt-1">{n.body}</div>
                <div className="text-xs text-ink-soft mt-2">{new Date(n.created_at).toLocaleString()}</div>
              </div>
              {!n.read && <button onClick={() => markRead(n.notification_id)} className="text-xs text-terracotta font-semibold" data-testid={`mark-read-${n.notification_id}`}><CheckCircle weight="duotone" /></button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
